export const webViewModalDataSet = { cy: 'web-view-modal' };

export const webViewModalCloseButtonDataSet = { cy: 'web-view-modal-close-button' };
